export const RightArrowline = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14.2598 15.7276L18.8027 20.2705L14.2598 24.8134L15.6553 26.2089L21.5937 20.2705L15.6553 14.332L14.2598 15.7276ZM24.5629 14.332H26.5424V26.2089H24.5629V14.332Z" />
      </svg>
    </div>
  );
};

export const RightArrow = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.0186 6.33203L8.62305 7.72756L13.1561 12.2705L8.62305 16.8134L10.0186 18.2089L15.957 12.2705L10.0186 6.33203Z" />
      </svg>
    </div>
  );
};
export const LeftArrow = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.7676 7.72756L14.372 6.33203L8.43359 12.2705L14.372 18.2089L15.7676 16.8134L11.2346 12.2705L15.7676 7.72756Z" />
      </svg>
    </div>
  );
};
export const LeftArrowline = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.1323 16.8134L14.5894 12.2705L19.1323 7.72756L17.7367 6.33203L11.7983 12.2705L17.7367 18.2089L19.1323 16.8134ZM6.84961 6.33203H8.82909V18.2089H6.84961V6.33203Z" />
      </svg>
    </div>
  );
};
export const P2pHelp = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="15"
        height="17"
        viewBox="0 0 15 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.41634 1.25H13.833V16.25H3.41634V14.1667H1.33301V12.0833H3.41634V9.79167H1.33301V7.70833H3.41634V5.41667H1.33301V3.33333H3.41634V1.25ZM8.62467 5.20833C8.04967 5.20833 7.58301 5.675 7.58301 6.25V6.66667H5.49967V6.25C5.49977 5.73613 5.62658 5.23022 5.86889 4.77706C6.11119 4.32391 6.4615 3.9375 6.88879 3.65205C7.31609 3.36661 7.80718 3.19094 8.31858 3.14061C8.82998 3.09028 9.34589 3.16683 9.82064 3.36349C10.2954 3.56015 10.7143 3.87085 11.0403 4.26807C11.3663 4.66529 11.5893 5.13678 11.6896 5.64076C11.7899 6.14475 11.7643 6.66569 11.6152 7.15745C11.4661 7.6492 11.198 8.09659 10.8347 8.46L9.66634 9.6275V10.8333H7.58301V8.765L9.36134 6.98667C9.50706 6.84099 9.6063 6.65536 9.64651 6.45327C9.68672 6.25118 9.66609 6.04171 9.58723 5.85134C9.50837 5.66098 9.37483 5.49828 9.20349 5.38382C9.03216 5.26937 8.83072 5.20829 8.62467 5.20833ZM7.58301 14.5833V12.5H9.66634V14.5833H7.58301Z"
          stroke="white"
        />
      </svg>
    </div>
  );
};
export const P2pOrder = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="14"
        height="17"
        viewBox="0 0 14 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.29688 1.25V16.25H12.9635V4.58333L9.63021 1.25H1.29688ZM3.79687 6.66667H10.4635V8.75H3.79687V6.66667ZM3.79687 10.8333H10.4635V12.9167H3.79687V10.8333Z"
          stroke="white"
        />
      </svg>
    </div>
  );
};
export const P2pUser = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.7197 1.08334H15.7197V4.83334H13.6364V3.16667H10.7197V1.08334ZM3.08056 6.08167C2.56493 6.08167 2.07043 6.2865 1.70583 6.6511C1.34122 7.0157 1.13639 7.51021 1.13639 8.02584V9.415H7.80306V8.02584C7.80306 7.77052 7.75277 7.51771 7.65507 7.28184C7.55737 7.04596 7.41416 6.83164 7.23363 6.6511C7.05309 6.47057 6.83877 6.32736 6.60289 6.22966C6.36702 6.13196 6.1142 6.08167 5.85889 6.08167H3.08056ZM10.5806 11.0833C10.0649 11.0833 9.57043 11.2882 9.20583 11.6528C8.84122 12.0174 8.63639 12.5119 8.63639 13.0275V14.4167H15.3031V13.0275C15.3031 12.5119 15.0982 12.0174 14.7336 11.6528C14.369 11.2882 13.8745 11.0833 13.3589 11.0833H10.5806ZM5.71973 12.3333H2.80306V10.6667H0.719727V14.4167H5.71973V12.3333ZM14.0531 8.16834C14.0531 8.72087 13.8336 9.25077 13.4429 9.64147C13.0522 10.0322 12.5223 10.2517 11.9697 10.2517C11.4172 10.2517 10.8873 10.0322 10.4966 9.64147C10.1059 9.25077 9.88639 8.72087 9.88639 8.16834C9.88639 7.6158 10.1059 7.0859 10.4966 6.6952C10.8873 6.3045 11.4172 6.085 11.9697 6.085C12.5223 6.085 13.0522 6.3045 13.4429 6.6952C13.8336 7.0859 14.0531 7.6158 14.0531 8.16834ZM4.46973 5.25C5.02226 5.25 5.55216 5.03051 5.94287 4.63981C6.33357 4.24911 6.55306 3.7192 6.55306 3.16667C6.55306 2.61413 6.33357 2.08423 5.94287 1.69353C5.55216 1.30283 5.02226 1.08334 4.46973 1.08334C3.91719 1.08334 3.38729 1.30283 2.99659 1.69353C2.60589 2.08423 2.38639 2.61413 2.38639 3.16667C2.38639 3.7192 2.60589 4.24911 2.99659 4.63981C3.38729 5.03051 3.91719 5.25 4.46973 5.25Z"
          stroke="white"
        />
      </svg>
    </div>
  );
};
export const P2pMore = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.96 18.25C11.9449 18.25 12.9201 18.056 13.8301 17.6791C14.74 17.3022 15.5668 16.7497 16.2633 16.0533C16.9597 15.3569 17.5121 14.5301 17.8891 13.6201C18.266 12.7102 18.46 11.7349 18.46 10.75C18.46 9.76509 18.266 8.78982 17.8891 7.87987C17.5121 6.96993 16.9597 6.14314 16.2633 5.4467C15.5668 4.75026 14.74 4.19781 13.8301 3.8209C12.9201 3.44399 11.9449 3.25 10.96 3.25C8.97084 3.25 7.06318 4.04018 5.65666 5.4467C4.25014 6.85322 3.45996 8.76088 3.45996 10.75C3.45996 12.7391 4.25014 14.6468 5.65666 16.0533C7.06318 17.4598 8.97084 18.25 10.96 18.25ZM8.25163 9.70833H6.16829V11.7917H8.25163V9.70833ZM15.7516 9.70833H13.6683V11.7917H15.7516V9.70833ZM9.91829 9.70833H12.0016V11.7917H9.91829V9.70833Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
export const Filter = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="15"
        height="18"
        viewBox="0 0 15 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5397 1.92587H1.87305V4.84254L6.03971 9.00921V16.0925L9.37305 14.16V9.00921L13.5397 4.84254V1.92587Z"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};
export const Refresh = () => {
  return (
    <div>
      <svg
        width="15"
        height="17"
        viewBox="0 0 15 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-black dark:stroke-white"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.4532 8.76755C14.4562 8.65091 14.4562 8.5342 14.4532 8.41755V8.76755ZM10.734 11.5401L8.56071 9.36672H14.4524V15.2592L12.5015 13.3076C11.67 14.138 10.6338 14.7339 9.49791 15.0351C8.36198 15.3362 7.16665 15.3318 6.03295 15.0224C4.89925 14.713 3.86744 14.1095 3.04199 13.2731C2.21654 12.4366 1.62676 11.3969 1.33238 10.2592H3.96904C4.24051 10.8811 4.65971 11.4273 5.19022 11.8503C5.72074 12.2733 6.34652 12.5604 7.01321 12.6866C7.67989 12.8129 8.36732 12.7744 9.01576 12.5746C9.6642 12.3748 10.254 12.0196 10.734 11.5401ZM14.2449 6.92589C13.9505 5.7881 13.3606 4.74831 12.5351 3.91182C11.7095 3.07534 10.6776 2.47187 9.54374 2.16253C8.40991 1.85319 7.21448 1.84897 6.07849 2.15029C4.94251 2.4516 3.90633 3.04776 3.07488 3.87839L1.12321 1.92589V7.81839H7.01488L4.84404 5.64589C5.32398 5.1661 5.91383 4.81077 6.56232 4.61079C7.21082 4.4108 7.89834 4.37221 8.56514 4.49836C9.23194 4.62451 9.85785 4.91158 10.3885 5.33464C10.9191 5.7577 11.3384 6.30394 11.6099 6.92589H14.2449ZM1.12238 8.59255V8.46339V8.72172C1.12197 8.67867 1.12197 8.63561 1.12238 8.59255Z"
        />
      </svg>
    </div>
  );
};
export const Pro = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.788086 0.371399H11.2881L14.2881 3.3714V13.8714H3.78809L0.788086 10.8714V0.371399ZM3.20159 9.6579H2.07809V4.4964H4.51784C5.47934 4.4964 6.08534 5.16915 6.08534 6.14565C6.08534 7.1214 5.47934 7.79415 4.51784 7.79415H3.20159V9.6579ZM3.20159 5.4729V6.8184H4.38509C4.71734 6.8184 4.92509 6.64065 4.92509 6.3084V5.9829C4.92509 5.6499 4.71734 5.4729 4.38509 5.4729H3.20159ZM7.89359 9.6579H6.79859V5.7759H7.89359V6.6189H7.93034C8.01884 6.1899 8.31509 5.7759 8.92109 5.7759H9.11384V6.7959H8.84009C8.20409 6.7959 7.89359 6.9369 7.89359 7.38765V9.6579ZM9.50834 7.71315C9.50834 8.96265 10.1886 9.7464 11.3271 9.7464C12.4663 9.7464 13.1466 8.96265 13.1466 7.71315C13.1466 6.46365 12.4663 5.68665 11.3271 5.68665C10.1886 5.68665 9.50834 6.46365 9.50834 7.71315ZM12.0073 8.11215C12.0073 8.59965 11.7561 8.88165 11.3271 8.88165C10.8988 8.88165 10.6468 8.6004 10.6468 8.11215V7.3209C10.6468 6.8334 10.8988 6.55215 11.3271 6.55215C11.7561 6.55215 12.0073 6.8334 12.0073 7.3209V8.11215Z"
          fill="#FF375B"
        />
      </svg>
    </div>
  );
};
export const Diamond = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.03848 13.8714L17.326 5.58315L12.4922 0.371399H5.58473L0.750977 5.58315L9.03773 13.8714H9.03848ZM11.86 3.5709L12.9212 4.6314L8.14823 9.4044L5.49623 6.7524L6.55673 5.6919L8.14823 7.2834L11.86 3.5709Z"
          fill="#8E60F0"
        />
      </svg>
    </div>
  );
};
export const ThumbsUp = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.14095 5.10338L6.43695 2.84272V0.628052H7.02895C7.57801 0.628052 8.10459 0.846119 8.4929 1.2343C8.8812 1.62248 9.09944 2.14899 9.09962 2.69805V3.81339H12.8076V8.09672C12.8076 8.94152 12.472 9.75172 11.8747 10.3491C11.2773 10.9465 10.4671 11.2821 9.62228 11.2821H4.14095V5.10338ZM2.80762 5.07805H0.807617V11.2821H2.80762V5.07805Z"
          fill="#848E9C"
        />
      </svg>
    </div>
  );
};
export const Clock = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="11"
        height="13"
        viewBox="0 0 11 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.37163 0.621399H7.70496V2.28807H2.37163V0.621399ZM7.98829 4.33807L9.03829 3.28807L10.217 4.46673L9.07363 5.6094C9.65939 6.61645 9.84728 7.80619 9.60038 8.94474C9.35348 10.0833 8.68964 11.0883 7.73935 11.7623C6.78906 12.4362 5.62105 12.7304 4.4649 12.5869C3.30875 12.4434 2.24809 11.8726 1.4914 10.9868C0.73471 10.101 0.336718 8.96414 0.375656 7.79977C0.414594 6.6354 0.887646 5.52771 1.70183 4.69441C2.51601 3.86112 3.61243 3.3625 4.77558 3.29656C5.93873 3.23062 7.08515 3.60213 7.98829 4.33807ZM5.87163 5.6214V8.95473H4.20496V5.6214H5.87163Z"
          fill="#848E9C"
        />
      </svg>
    </div>
  );
};
export const Verify = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.1957 2.35609L9.97769 0.246338L7.86719 1.46434L5.75744 0.246338L4.53869 2.35609H2.10194V4.79359L-0.0078125 6.01084L1.21019 8.12134L-0.0078125 10.2311L2.10194 11.4498V13.8858H4.53944L5.75669 15.9963L7.86719 14.7783L9.97694 15.9963L11.1957 13.8858H13.6317V11.4498L15.7422 10.2318L14.5242 8.12134L15.7422 6.01159L13.6317 4.79284V2.35609H11.1957ZM10.5192 5.51734L11.5797 6.57784L6.80669 11.3508L4.15469 8.69884L5.21519 7.63834L6.80669 9.22984L10.5192 5.51734Z"
          fill="url(#paint0_linear_65_1978)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_65_1978"
            x1="14.5841"
            y1="0.24634"
            x2="-0.737464"
            y2="1.52527"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
export const Region = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.3026 15.5951C12.5518 15.1139 13.6496 14.3075 14.4824 13.2595C15.3152 12.2114 15.8527 10.9598 16.0393 9.63425H12.7543C12.6318 12.0176 12.0935 14.1242 11.3035 15.5951H11.3026ZM10.6718 9.63425C10.5234 13.0526 9.65762 15.6759 8.61095 15.6759C7.56428 15.6759 6.69845 13.0526 6.55012 9.63425H10.6718ZM10.6718 7.55091H6.55012C6.69845 4.13258 7.56428 1.50925 8.61095 1.50925C9.65762 1.50925 10.5234 4.13258 10.6718 7.55091ZM12.7543 7.55091H16.0393C15.8529 6.2254 15.3155 4.9738 14.4829 3.92576C13.6502 2.87771 12.5525 2.07131 11.3035 1.59008C12.0935 3.06091 12.6318 5.16758 12.7543 7.55091ZM4.47428 7.55091C4.59678 5.16591 5.13512 3.05758 5.92678 1.58758C4.67583 2.06781 3.57619 2.87406 2.74196 3.92267C1.90774 4.97127 1.36933 6.22402 1.18262 7.55091H4.47428ZM4.47428 9.63425H1.18262C1.36919 10.9613 1.90753 12.2142 2.74177 13.263C3.576 14.3117 4.67572 15.1181 5.92678 15.5984C5.13512 14.1276 4.59678 12.0192 4.47428 9.63425Z"
          stroke="white"
        />
      </svg>
    </div>
  );
};
export const Info = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-badge-info-icon lucide-badge-info"
      >
        <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
        <line x1="12" x2="12" y1="16" y2="12" />
        <line x1="12" x2="12.01" y1="8" y2="8" />
      </svg>
    </div>
  );
};
export const Combine = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="14"
        height="11"
        viewBox="0 0 14 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_251_8192)">
          <path
            d="M7 0H13.4V1H7V0ZM7 3.4H13.4V4.4H7V3.4ZM7 6.7H13.4V7.7H7V6.7ZM7 10H13.4V11H7V10Z"
            fill="#8D96A6"
          />
          <path d="M0 0H5V4.5H0V0Z" fill="#FF4A49" />
          <path d="M0 6.5H5V11H0V6.5Z" fill="#26C487" />
        </g>
        <defs>
          <clipPath id="clip0_251_8192">
            <rect width="14" height="11" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export const Switch = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.138672" width="16" height="16" fill="black" />
      </svg>
    </div>
  );
};
export const Red = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="14"
        height="11"
        viewBox="0 0 14 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_251_8201)">
          <g clipPath="url(#clip1_251_8201)">
            <g clipPath="url(#clip2_251_8201)">
              <path
                d="M7 0H13.4V1H7V0ZM7 3.4H13.4V4.4H7V3.4ZM7 6.7H13.4V7.7H7V6.7ZM7 10H13.4V11H7V10Z"
                fill="#8D96A6"
              />
              <path d="M0 0H5V11H0V0Z" fill="#FF4A49" />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_251_8201">
            <rect width="14" height="11" fill="white" />
          </clipPath>
          <clipPath id="clip1_251_8201">
            <rect width="14" height="11" fill="white" />
          </clipPath>
          <clipPath id="clip2_251_8201">
            <rect width="14" height="11" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export const Green = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="14"
        height="11"
        viewBox="0 0 14 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_251_8196)">
          <g clipPath="url(#clip1_251_8196)">
            <g clipPath="url(#clip2_251_8196)">
              <path
                d="M7 0H13.4V1H7V0ZM7 3.4H13.4V4.4H7V3.4ZM7 6.7H13.4V7.7H7V6.7ZM7 10H13.4V11H7V10Z"
                fill="#8D96A6"
              />
              <path d="M0 0H5V11H0V0Z" fill="#26C487" />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_251_8196">
            <rect width="14" height="11" fill="white" />
          </clipPath>
          <clipPath id="clip1_251_8196">
            <rect width="14" height="11" fill="white" />
          </clipPath>
          <clipPath id="clip2_251_8196">
            <rect width="14" height="11" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export const NoRecord = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        width="60"
        height="52"
        viewBox="0 0 60 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.782349 12.6242C0.277046 12.7037 -0.0681233 13.1778 0.0113935 13.6833L3.83219 37.9593C3.91171 38.4646 4.38578 38.8097 4.89122 38.7302L22.5712 35.9476C23.0765 35.8681 23.4217 35.3939 23.3422 34.8886L20.1508 14.6114L14.2786 10.5L0.782349 12.6242Z"
          fill="#F5F5F5"
        />
        <path
          d="M15.651 15.3198L20.1514 14.6114L14.2793 10.5L14.9585 14.8157C15.0106 15.1462 15.3206 15.3718 15.651 15.3198Z"
          fill="#D6D6D6"
        />
        <path
          d="M14.2793 10.5L14.9585 14.8157C15.0105 15.1462 15.3204 15.3718 15.6509 15.3198L20.1513 14.6114"
          stroke="#262626"
          strokeWidth="0.0376946"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5435 26.9597C10.4463 26.3413 10.4151 25.8358 10.45 25.4436C10.4849 25.0513 10.6138 24.6766 10.837 24.3192C10.9645 24.1057 11.1171 23.9153 11.295 23.7476C11.4726 23.5802 11.6333 23.4071 11.7773 23.2285C11.9209 23.0504 12.0357 22.8575 12.1214 22.6506C12.2069 22.4437 12.2259 22.1885 12.178 21.8843C12.0973 21.3709 11.8992 21.0339 11.5839 20.874C11.2687 20.7141 10.9169 20.6648 10.5292 20.7257C9.97345 20.8132 9.61521 21.0282 9.45438 21.3702C9.29329 21.7126 9.2278 22.1498 9.25793 22.6822L7.22956 23.0015C7.14867 22.488 7.15899 22.0083 7.26079 21.5624C7.36246 21.1168 7.54488 20.7228 7.80792 20.3805C8.07082 20.0385 8.4076 19.7544 8.81797 19.5287C9.22808 19.3031 9.69541 19.1489 10.2197 19.0663C11.3518 18.8882 12.2818 18.9781 13.0097 19.3362C13.7373 19.6946 14.183 20.3924 14.3463 21.4302C14.3992 21.7659 14.4111 22.0645 14.3828 22.3269C14.354 22.5892 14.2877 22.8333 14.1838 23.0592C14.0796 23.2851 13.942 23.5028 13.771 23.7124C13.5997 23.922 13.4034 24.1409 13.1815 24.3691C12.9789 24.5837 12.8189 24.7783 12.7011 24.9523C12.5835 25.1266 12.5011 25.3035 12.4543 25.4826C12.4072 25.662 12.3877 25.8451 12.3957 26.0317C12.4035 26.2185 12.4258 26.4273 12.462 26.6578L10.5435 26.9597ZM10.9585 30.0044L10.6342 27.9446L12.7569 27.6104L13.0812 29.6703L10.9585 30.0044Z"
          fill="#D6D6D6"
        />
        <path
          d="M20.9296 28.1768C23.27 30.4771 25.992 33.5812 28.5214 37.5917C30.2811 40.3818 31.5857 43.0366 32.5592 45.3728C30.3159 46.3823 28.0728 47.3917 25.8295 48.4012L20.0625 28.7759L20.9296 28.1768Z"
          fill="url(#paint0_linear_251_8516)"
        />
        <path
          d="M16.68 26.5898L20.9944 27.9383C22.1765 29.8131 22.8593 31.4739 23.26 32.6288C25.1268 38.0078 24.528 42.9304 24.3588 44.3215C24.3588 44.3215 24.3559 44.3453 23.812 48.4013H4.08562C4.02027 46.9312 4.03293 44.898 4.38002 42.513C4.79164 39.6848 5.17381 37.0594 6.88466 34.1759C7.58037 33.0034 10.0011 29.2514 14.6426 27.2873C15.4706 26.9369 16.1863 26.7208 16.68 26.5898Z"
          fill="url(#paint1_linear_251_8516)"
        />
        <path
          d="M6.53189 34.8022C8.93335 35.5726 11.9914 36.3287 15.5853 36.697C18.9331 37.0401 21.8841 36.9583 24.276 36.7337C24.3445 37.2979 24.4131 37.8621 24.4818 38.4264C21.9273 38.6347 18.8896 38.6976 15.4907 38.4004C11.6831 38.0675 8.38458 37.3667 5.70508 36.6143C5.98064 36.0103 6.25619 35.4063 6.53189 34.8022Z"
          fill="#2B3139"
        />
        <path
          opacity="0.5"
          d="M25.0426 33.2939L26.0198 33.512L22.4617 48.4011H20.4473L25.0426 33.2939Z"
          fill="url(#paint2_linear_251_8516)"
        />
        <path
          d="M17.0604 45.5493L17.8972 45.289L19.8153 46.2805L20.299 45.1076L17.8648 44.1714L16.8711 44.6371L17.0604 45.5493Z"
          fill="url(#paint3_linear_251_8516)"
        />
        <path
          opacity="0.5"
          d="M4.05469 46.172C6.01028 46.661 8.34805 47.0985 11.0043 47.3106C13.333 47.4966 15.4395 47.4721 17.2594 47.3497C17.2594 46.6023 17.2594 45.8549 17.2594 45.1073C12.9182 44.6224 8.57683 44.1373 4.2356 43.6523L4.05469 46.172Z"
          fill="url(#paint4_linear_251_8516)"
        />
        <path
          d="M18.4213 29.6909C17.2014 29.4818 16.3821 28.3235 16.5912 27.1037L17.406 22.3506L21.8235 23.1079L21.0086 27.861C20.7997 29.0807 19.6412 29.9001 18.4213 29.6909Z"
          fill="#F7A99C"
        />
        <path
          d="M21.2364 26.53L18.6203 24.5488C18.6059 24.8029 18.5647 25.9976 19.4491 26.9827C20.0137 27.6117 20.6812 27.8498 20.9932 27.9388L21.2364 26.53Z"
          fill="#FF7769"
        />
        <path
          d="M17.5574 20.8599C17.556 20.7858 17.386 20.6442 17.3344 20.5969C17.2473 20.517 17.1498 20.4482 17.0452 20.393C16.842 20.286 16.6081 20.2284 16.3778 20.2403C15.92 20.264 15.465 20.5654 15.3123 21.0055C15.2236 21.2611 15.2367 21.5439 15.3071 21.8052C15.4129 22.198 15.6469 22.5536 15.9591 22.8144C16.2177 23.0307 16.5288 23.1819 16.8563 23.2596C16.9219 23.2751 17.6031 23.3783 17.6025 23.3515C17.5875 22.521 17.5724 21.6905 17.5574 20.8599Z"
          fill="#F7A99C"
        />
        <path
          d="M16.9432 20.7997C16.9333 21.1633 16.917 23.0871 18.3703 24.7032C18.6381 25.0009 20.418 26.9802 22.4443 26.5219C25.0481 25.933 25.4823 21.9019 25.5029 21.6831C25.5731 20.9434 25.7796 18.765 24.2011 17.3065C22.9128 16.1162 21.2788 16.1843 21.0465 16.1977C20.8017 16.2117 19.2372 16.327 18.0629 17.6351C16.9971 18.8224 16.9594 20.2047 16.9432 20.7997Z"
          fill="#F7A99C"
        />
        <path
          d="M24.1258 21.4446C24.1104 21.7625 24.3106 22.0306 24.5731 22.0434C24.8356 22.0562 25.0609 21.8088 25.0763 21.4909C25.0919 21.173 24.8916 20.9049 24.6291 20.8921C24.3666 20.8793 24.1412 21.1266 24.1258 21.4446Z"
          fill="#262626"
        />
        <path
          d="M23.1989 21.7617L23.5269 22.4175C23.5871 22.538 23.531 22.6844 23.4054 22.7335L22.9688 22.9045"
          stroke="#262626"
          strokeWidth="0.234546"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.0633 22.6055C20.0459 22.9623 20.3211 23.2656 20.6778 23.2829C21.0345 23.3003 21.3379 23.0251 21.3552 22.6684C21.3726 22.3117 21.0974 22.0083 20.7407 21.991C20.384 21.9737 20.0806 22.2488 20.0633 22.6055Z"
          fill="#FF7769"
        />
        <path
          d="M16.9818 22.404C16.9961 22.3344 17.0853 21.8614 16.7649 21.4528C16.5139 21.1327 16.1704 21.0544 16.0762 21.0361"
          stroke="#262626"
          strokeWidth="0.234546"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.7848 21.5533C16.7642 21.5463 16.5156 21.4663 16.3037 21.6278C16.1295 21.7605 16.1085 21.9589 16.1055 21.9919"
          stroke="#262626"
          strokeWidth="0.234546"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.0317 22.4378C25.1551 22.4439 25.2675 22.4858 25.3627 22.5506C25.2905 22.8904 25.1848 23.2994 25.0325 23.7264C25.0112 23.7275 24.9906 23.7308 24.9688 23.7297C24.6121 23.7124 24.337 23.409 24.3543 23.0523C24.3716 22.6955 24.675 22.4203 25.0317 22.4378Z"
          fill="#FF7769"
        />
        <path
          d="M21.5901 20.7607L22.1284 21.3716L21.3574 21.6431"
          stroke="#262626"
          strokeWidth="0.234546"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3574 24.2068L23.2955 24.4276C23.2903 24.388 23.2054 23.8155 22.7454 23.6074C22.2944 23.4034 21.659 23.6293 21.3574 24.2068Z"
          fill="white"
        />
        <path
          d="M16.9643 20.3539C17.0711 20.3955 17.3228 20.5098 17.5231 20.779C17.7076 21.0272 17.7519 21.2772 17.765 21.3915C19.7752 21.2007 20.9356 20.6358 21.6345 20.1272C21.6345 20.1272 21.6855 20.0901 23.1592 18.9705C23.3967 19.2265 23.7685 19.5698 24.2949 19.8643C24.7721 20.1313 25.2139 20.2677 25.5374 20.3407C26.5938 20.0949 27.3304 19.3056 27.3549 18.4816C27.3806 17.6136 26.6091 16.9566 26.0616 16.6835C25.168 16.2379 24.757 16.7578 23.4469 16.4146C22.3909 16.1379 22.4303 15.7405 21.4401 15.5006C21.1409 15.4281 19.8976 15.1268 18.6483 15.7845C17.5947 16.3393 16.7599 17.4587 16.6768 18.7497C16.6311 19.4561 16.8228 20.0259 16.9643 20.3539Z"
          fill="#262626"
        />
        <path
          d="M16.6799 26.5898C14.9071 26.994 11.591 28.0149 8.50192 30.7782C8.50192 30.7782 5.38865 33.5632 3.26536 38.7276C3.0773 39.1851 2.86681 39.668 2.63445 40.6833C2.45437 41.4703 2.3732 42.196 2.34665 42.8298C2.32684 43.3036 2.61877 43.7346 3.06437 43.8964C3.4559 44.0385 3.90659 44.197 4.40625 44.3636C5.3317 44.6722 7.38442 45.513 9.70966 45.8357C14.5585 46.5087 17.2504 46.677 17.2504 46.677L17.6029 38.307L11.1937 37.4958L16.6799 26.5898Z"
          fill="url(#paint5_linear_251_8516)"
        />
        <path
          d="M21.8594 30.894C22.6644 33.7096 23.1633 36.0667 23.4789 37.7855"
          stroke="#262626"
          strokeWidth="0.137572"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M13.475 30.3887L9.87891 38.4898H12.0554L13.475 30.3887Z"
          fill="url(#paint6_linear_251_8516)"
        />
        <path
          d="M25.5517 33.4371L23.6094 32.8867L19.3699 47.849L21.3123 48.3993L25.5517 33.4371Z"
          fill="#B3B8FA"
        />
        <path
          d="M17.4611 40.2776C17.4611 40.2776 21.1056 39.9147 21.4941 40.0345C21.8826 40.1543 23.2124 40.9071 23.4003 41.1219C23.5882 41.3366 23.6553 41.538 23.6285 41.7394C23.6017 41.9408 23.3331 42.1689 23.3331 42.1689C23.5435 42.4966 23.5508 42.7211 23.5059 42.8729C23.4259 43.144 23.1078 43.4272 23.1049 43.4307C23.1284 43.5146 23.1549 43.635 23.162 43.7814C23.1689 43.9205 23.1826 44.2006 23.0444 44.4563C22.8391 44.8359 22.4166 44.9441 22.3242 44.9656C22.3242 44.9656 22.4875 45.2698 22.2727 45.5248C22.058 45.7799 21.4136 46.1021 20.6484 45.9946C19.8832 45.8872 17.8964 44.9073 17.8964 44.9073L17.2578 45.1072L17.4611 40.2776Z"
          fill="#F7A99C"
        />
        <path
          opacity="0.5"
          d="M27.4179 33.294C32.315 33.294 36.285 29.3242 36.285 24.427C36.285 19.5299 32.315 15.5601 27.4179 15.5601C22.5207 15.5601 18.5508 19.5299 18.5508 24.427C18.5508 29.3242 22.5207 33.294 27.4179 33.294Z"
          fill="#CDEBF5"
        />
        <path
          d="M27.4178 14.4077C21.8843 14.4077 17.3984 18.8935 17.3984 24.427C17.3984 29.9605 21.8843 34.4463 27.4178 34.4463C32.9514 34.4463 37.4372 29.9605 37.4372 24.427C37.4372 18.8935 32.9514 14.4077 27.4178 14.4077ZM27.4178 32.8103C22.7878 32.8103 19.0344 29.0569 19.0344 24.427C19.0344 19.7971 22.7878 16.0437 27.4178 16.0437C32.0478 16.0437 35.8012 19.7971 35.8012 24.427C35.8012 29.0569 32.0478 32.8103 27.4178 32.8103Z"
          fill="#B3B8FA"
        />
        <path
          d="M23.3336 42.1689C23.3336 42.1689 21.9914 41.9186 21.3134 41.6032C20.6351 41.2877 20.3828 41.1143 20.3828 41.1143"
          stroke="#262626"
          strokeWidth="0.206357"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.1055 43.4308C23.1055 43.4308 21.5499 43.2752 20.919 42.9124C20.2881 42.5496 20.0625 42.313 20.0625 42.313"
          stroke="#262626"
          strokeWidth="0.206357"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5925 44.8705C21.9264 44.8444 21.4259 44.6957 21.0767 44.5524C20.4948 44.3138 19.7676 43.8584 19.7676 43.8584"
          stroke="#262626"
          strokeWidth="0.206357"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4611 40.2778L17.2578 45.1075L17.8964 44.9076L17.6917 40.2554L17.4611 40.2778Z"
          fill="#FF7769"
        />
        <path
          d="M13.2232 30.894C13.2232 30.894 9.88005 38.244 9.97443 38.4333C10.0687 38.6226 17.603 38.3072 17.603 38.3072L17.2505 46.6771C17.2505 46.6771 11.3679 46.3053 9.04072 45.7278C6.71355 45.1502 4.05469 44.2453 4.05469 44.2453"
          stroke="#262626"
          strokeWidth="0.137572"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.8738 18.4913C27.8219 18.6069 27.814 18.7421 27.862 18.87C27.9586 19.1276 28.2457 19.258 28.5031 19.1614C28.971 18.9859 29.4778 18.9119 29.9685 18.9475C30.517 18.9873 30.937 19.1521 31.1385 19.2467C31.3776 19.3591 31.8751 19.593 32.2459 20.1034C32.7623 20.8142 32.7191 21.6459 32.6766 21.9706C32.6408 22.2433 32.833 22.4932 33.1057 22.529C33.3785 22.5648 33.6286 22.3723 33.6641 22.0999C33.7362 21.5498 33.7524 20.4826 33.0516 19.518C32.5304 18.8004 31.8519 18.4815 31.5621 18.3453C31.2395 18.1937 30.7137 18.0029 30.0403 17.9541C29.4072 17.9083 28.7546 18.0032 28.1531 18.229C28.0236 18.2775 27.9262 18.3744 27.8738 18.4913Z"
          fill="white"
        />
        <path
          d="M10.4361 30.147C9.22021 31.228 7.65862 32.8423 6.23323 35.079C4.76974 37.3758 3.95916 39.5293 3.49609 41.114"
          stroke="white"
          strokeWidth="0.137572"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.9896 48.4012H19.1003C18.5196 48.4012 18.0488 47.9304 18.0488 47.3498V46.6768H33.9898V48.4012H33.9896Z"
          fill="#2A83C6"
        />
        <path
          d="M45.0968 48.4011H28.8527C28.2148 48.4011 27.7608 47.856 27.8388 47.1832L29.0665 36.591C29.1445 35.9184 29.7248 35.373 30.3627 35.373H46.6068C47.2448 35.373 47.6987 35.9184 47.6207 36.591L46.3931 47.1832C46.315 47.8558 45.7348 48.4011 45.0968 48.4011Z"
          fill="#2A83C6"
        />
        <path
          d="M46.6652 48.4011H30.4211C29.7831 48.4011 29.3292 47.856 29.4072 47.1832L30.6349 36.591C30.7129 35.9184 31.2931 35.373 31.9311 35.373H48.1752C48.8131 35.373 49.2671 35.9184 49.1891 36.591L47.9614 47.1832C47.8835 47.8558 47.3031 48.4011 46.6652 48.4011Z"
          fill="#3897E9"
        />
        <path
          d="M49.1903 37.2002L47.9626 47.2462C47.9626 47.2462 48.0175 48.4012 46.1249 48.4012C44.2322 48.4012 35.4941 48.4012 35.4941 48.4012C36.6385 48.3939 40.6458 48.229 44.3268 45.2152C48.0006 42.2075 48.9559 38.3219 49.1903 37.2002Z"
          fill="#5FBBFF"
        />
        <path
          d="M48.8519 38.4902C48.484 39.681 47.5902 42.0126 45.4482 44.1901C43.3351 46.3382 41.0552 47.2711 39.875 47.664"
          stroke="#262626"
          strokeWidth="0.137572"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.3021 42.9473H38.7344L39.0962 40.6445H39.6641L39.3021 42.9473Z"
          fill="url(#paint7_linear_251_8516)"
        />
        <path
          d="M40.0463 42.9472H39.4785L39.7279 41.3594H40.2958L40.0463 42.9472Z"
          fill="url(#paint8_linear_251_8516)"
        />
        <path
          d="M23.4331 15.8228C22.6137 16.2851 20.5444 17.5955 19.1867 20.2386C17.8327 22.8744 17.9686 25.3125 18.0689 26.2486"
          stroke="#262626"
          strokeWidth="0.137572"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.4345 43.7324L24.1152 41.48"
          stroke="#262626"
          strokeWidth="0.137572"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.9258 41.4836H34.6428C34.1551 41.4836 33.7598 41.0883 33.7598 40.6006V25.0193C33.7598 24.5316 34.1551 24.1362 34.6428 24.1362H55.9257C56.4134 24.1362 56.8088 24.5316 56.8088 25.0193V40.6006C56.8089 41.0884 56.4135 41.4836 55.9258 41.4836Z"
          fill="#F5F5F5"
        />
        <path
          opacity="0.5"
          d="M56.8089 26.1433V25.0193C56.8089 24.5316 56.4135 24.1362 55.9258 24.1362H34.6428C34.1551 24.1362 33.7598 24.5316 33.7598 25.0193V26.1433H56.8089Z"
          fill="#D6D6D6"
        />
        <path
          d="M34.9588 25.245C34.9588 25.3961 34.8364 25.5184 34.6855 25.5184C34.5344 25.5184 34.4121 25.3959 34.4121 25.245C34.4121 25.0941 34.5346 24.9717 34.6855 24.9717C34.8364 24.9715 34.9588 25.094 34.9588 25.245Z"
          fill="#F5F5F5"
        />
        <path
          d="M35.8221 25.245C35.8221 25.3961 35.6997 25.5184 35.5487 25.5184C35.3977 25.5184 35.2754 25.3959 35.2754 25.245C35.2754 25.0941 35.3978 24.9717 35.5487 24.9717C35.6997 24.9715 35.8221 25.094 35.8221 25.245Z"
          fill="#F5F5F5"
        />
        <path
          d="M36.7069 25.245C36.7069 25.3961 36.5844 25.5184 36.4335 25.5184C36.2825 25.5184 36.1602 25.3959 36.1602 25.245C36.1602 25.0941 36.2826 24.9717 36.4335 24.9717C36.5844 24.9715 36.7069 25.094 36.7069 25.245Z"
          fill="#F5F5F5"
        />
        <path
          opacity="0.5"
          d="M47.7754 30.265V29.1402C47.7754 28.7712 47.4764 28.4722 47.1074 28.4722H40.5782C40.2092 28.4722 39.9102 28.7712 39.9102 29.1402V30.265V37.7583C39.9102 38.1273 40.2092 38.4264 40.5782 38.4264H51.019C51.388 38.4264 51.687 38.1273 51.687 37.7583V30.933C51.687 30.5641 51.388 30.265 51.019 30.265H47.7754Z"
          fill="#D6D6D6"
        />
        <path
          d="M47.114 31.8359L45.7986 33.1514L44.4832 31.8359L43.6895 32.6297L45.0049 33.945L43.6895 35.2605L44.4832 36.0543L45.7986 34.7388L47.114 36.0543L47.9078 35.2605L46.5924 33.945L47.9078 32.6297L47.114 31.8359Z"
          fill="#D6D6D6"
        />
        <path
          d="M34.6426 24.1362H55.9254C56.4131 24.1362 56.8085 24.5316 56.8085 25.0193V40.6006"
          stroke="#262626"
          strokeWidth="0.0376946"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.5333 51.3344H1.46652C0.656633 51.3344 0 50.6778 0 49.8679C0 49.058 0.656633 48.4014 1.46652 48.4014H58.5335C59.3434 48.4014 60 49.058 60 49.8679C59.9999 50.6778 59.3434 51.3344 58.5333 51.3344Z"
          fill="#FDB6D6"
        />
        <path
          d="M54.8051 28.1485C54.7039 27.3431 54.6839 26.6868 54.7451 26.18C54.8063 25.6732 54.9884 25.1926 55.2921 24.7385C55.4661 24.4671 55.6715 24.2265 55.9087 24.0163C56.1456 23.8065 56.3609 23.5887 56.5547 23.3631C56.748 23.1379 56.9044 22.8927 57.024 22.628C57.1432 22.3635 57.1782 22.0333 57.1284 21.6372C57.0445 20.9685 56.8014 20.5239 56.3992 20.3039C55.9971 20.0839 55.5434 20.0058 55.0385 20.0692C54.3147 20.1601 53.8418 20.4243 53.6195 20.8611C53.3969 21.2983 53.2944 21.8623 53.3118 22.5535L50.6703 22.8851C50.5863 22.2164 50.6191 21.595 50.769 21.0215C50.9186 20.4482 51.1711 19.9448 51.5259 19.5119C51.8805 19.0792 52.3282 18.7247 52.8693 18.4488C53.4098 18.1729 54.0217 17.992 54.7045 17.9063C56.1789 17.7211 57.3804 17.8755 58.3092 18.3688C59.2376 18.8626 59.7871 19.7848 59.9569 21.1365C60.0118 21.5735 60.0152 21.9612 59.9679 22.2999C59.9201 22.6388 59.8241 22.9524 59.6803 23.2409C59.5362 23.5294 59.3489 23.806 59.1189 24.0706C58.8885 24.3354 58.6252 24.611 58.3284 24.8979C58.0571 25.168 57.8418 25.4134 57.6824 25.6344C57.5229 25.8556 57.4089 26.0815 57.3411 26.3116C57.2728 26.5422 57.2402 26.7787 57.2428 27.0208C57.2453 27.2633 57.2658 27.5348 57.3035 27.8348L54.8051 28.1485ZM55.2196 32.1111L54.8826 29.4284L57.6472 29.0813L57.9841 31.764L55.2196 32.1111Z"
          fill="#2B3139"
        />
        <path
          d="M48.3437 15.0074C51.1066 12.2446 51.1066 7.76518 48.3437 5.00235C45.5809 2.23953 41.1014 2.23953 38.3385 5.00235C35.5757 7.76517 35.5757 12.2446 38.3385 15.0074C41.1014 17.7702 45.5809 17.7702 48.3437 15.0074Z"
          fill="#F5F5F5"
        />
        <path
          opacity="0.5"
          d="M47.4014 14.0644C49.6434 11.8224 49.6434 8.18737 47.4014 5.94535C45.1594 3.70333 41.5243 3.70333 39.2822 5.94535C37.0402 8.18737 37.0402 11.8224 39.2822 14.0644C41.5243 16.3064 45.1594 16.3064 47.4014 14.0644Z"
          fill="#D6D6D6"
        />
        <path
          d="M43.5308 5.96484H43.1523V10.6363H43.5308V5.96484Z"
          fill="#D6D6D6"
        />
        <path
          d="M43.3416 10.2898L43.1523 10.6177L45.7735 12.131L45.9628 11.8032L43.3416 10.2898Z"
          fill="#D6D6D6"
        />
        <defs>
          <linearGradient
            id="paint0_linear_251_8516"
            x1="31.6403"
            y1="28.1768"
            x2="19.4313"
            y2="28.8065"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_251_8516"
            x1="23.0756"
            y1="26.5898"
            x2="3.0878"
            y2="28.1603"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_251_8516"
            x1="25.61"
            y1="33.2939"
            x2="20.1565"
            y2="33.4619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_251_8516"
            x1="20.0469"
            y1="44.1714"
            x2="16.7497"
            y2="44.6187"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_251_8516"
            x1="16.2885"
            y1="43.6523"
            x2="4.36044"
            y2="47.1181"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_251_8516"
            x1="16.481"
            y1="26.5898"
            x2="1.5953"
            y2="27.5336"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_251_8516"
            x1="13.2106"
            y1="30.3887"
            x2="9.69276"
            y2="30.519"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_251_8516"
            x1="39.5957"
            y1="40.6445"
            x2="38.686"
            y2="40.6752"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_251_8516"
            x1="40.2357"
            y1="41.3594"
            x2="39.4366"
            y2="41.3937"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#237249" />
            <stop offset="1" stopColor="#35C66B" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export const Calender = () => {
  return (
    <div className="text-black dark:text-titleGray">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-4 h-4  dark:text-white"
        fill="none"
        viewBox="0 0 25 25"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
    </div>
  );
};
export const Facebook = () => {
  return (
    <div className="text-black dark:text-gray-300">
      <svg
        width="23"
        height="23"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 5C16.2 5 5 16.2 5 30C5 43.8 16.2 55 30 55C43.8 55 55 43.8 55 30C55 16.2 43.8 5 30 5ZM41.6 22C41.225 25.95 39.6 35.55 38.775 39.975C38.425 41.85 37.725 42.475 37.075 42.55C35.625 42.675 34.525 41.6 33.125 40.675C30.925 39.225 29.675 38.325 27.55 36.925C25.075 35.3 26.675 34.4 28.1 32.95C28.475 32.575 34.875 26.75 35 26.225C35.0174 26.1455 35.0151 26.0629 34.9933 25.9845C34.9715 25.9061 34.9309 25.8342 34.875 25.775C34.725 25.65 34.525 25.7 34.35 25.725C34.125 25.775 30.625 28.1 23.8 32.7C22.8 33.375 21.9 33.725 21.1 33.7C20.2 33.675 18.5 33.2 17.225 32.775C15.65 32.275 14.425 32 14.525 31.125C14.575 30.675 15.2 30.225 16.375 29.75C23.675 26.575 28.525 24.475 30.95 23.475C37.9 20.575 39.325 20.075 40.275 20.075C40.475 20.075 40.95 20.125 41.25 20.375C41.5 20.575 41.575 20.85 41.6 21.05C41.575 21.2 41.625 21.65 41.6 22Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
export const Insta = () => {
  return (
    <div className="text-black dark:text-gray-300">
      <svg
        width="22"
        height="22"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1150_317)">
          <path
            d="M32.57 5C35.3825 5.0075 36.81 5.0225 38.0425 5.0575L38.5275 5.075C39.0875 5.095 39.64 5.12 40.3075 5.15C42.9675 5.275 44.7825 5.695 46.375 6.3125C48.025 6.9475 49.415 7.8075 50.805 9.195C52.0767 10.4443 53.0604 11.9562 53.6875 13.625C54.305 15.2175 54.725 17.0325 54.85 19.695C54.88 20.36 54.905 20.9125 54.925 21.475L54.94 21.96C54.9775 23.19 54.9925 24.6175 54.9975 27.43L55 29.295V32.57C55.0061 34.3935 54.9869 36.217 54.9425 38.04L54.9275 38.525C54.9075 39.0875 54.8825 39.64 54.8525 40.305C54.7275 42.9675 54.3025 44.78 53.6875 46.375C53.0604 48.0438 52.0767 49.5557 50.805 50.805C49.5557 52.0767 48.0438 53.0605 46.375 53.6875C44.7825 54.305 42.9675 54.725 40.3075 54.85L38.5275 54.925L38.0425 54.94C36.81 54.975 35.3825 54.9925 32.57 54.9975L30.705 55H27.4325C25.6081 55.0064 23.7838 54.9873 21.96 54.9425L21.475 54.9275C20.8815 54.905 20.2882 54.8792 19.695 54.85C17.035 54.725 15.22 54.305 13.625 53.6875C11.9571 53.0601 10.4461 52.0764 9.19749 50.805C7.92485 49.5559 6.94026 48.044 6.31249 46.375C5.69499 44.7825 5.27499 42.9675 5.14999 40.305L5.07499 38.525L5.06249 38.04C5.0164 36.217 4.99557 34.3935 4.99999 32.57V27.43C4.99307 25.6065 5.0114 23.783 5.05499 21.96L5.07249 21.475C5.09249 20.9125 5.11749 20.36 5.14749 19.695C5.27249 17.0325 5.69249 15.22 6.30999 13.625C6.93922 11.9555 7.92555 10.4436 9.19999 9.195C10.4479 7.92387 11.958 6.94018 13.625 6.3125C15.22 5.695 17.0325 5.275 19.695 5.15C20.36 5.12 20.915 5.095 21.475 5.075L21.96 5.06C23.783 5.01558 25.6065 4.99641 27.43 5.0025L32.57 5ZM30 17.5C26.6848 17.5 23.5054 18.817 21.1612 21.1612C18.8169 23.5054 17.5 26.6848 17.5 30C17.5 33.3152 18.8169 36.4946 21.1612 38.8388C23.5054 41.183 26.6848 42.5 30 42.5C33.3152 42.5 36.4946 41.183 38.8388 38.8388C41.183 36.4946 42.5 33.3152 42.5 30C42.5 26.6848 41.183 23.5054 38.8388 21.1612C36.4946 18.817 33.3152 17.5 30 17.5ZM30 22.5C30.9849 22.4998 31.9602 22.6937 32.8702 23.0704C33.7802 23.4472 34.6071 23.9995 35.3037 24.6958C36.0002 25.3921 36.5528 26.2188 36.9299 27.1287C37.3069 28.0386 37.5011 29.0138 37.5012 29.9988C37.5014 30.9837 37.3076 31.959 36.9308 32.869C36.5541 33.779 36.0017 34.6059 35.3054 35.3024C34.6091 35.999 33.7824 36.5516 32.8725 36.9286C31.9626 37.3057 30.9874 37.4998 30.0025 37.5C28.0134 37.5 26.1057 36.7098 24.6992 35.3033C23.2927 33.8968 22.5025 31.9891 22.5025 30C22.5025 28.0109 23.2927 26.1032 24.6992 24.6967C26.1057 23.2902 28.0134 22.5 30.0025 22.5M43.1275 13.75C42.2987 13.75 41.5038 14.0792 40.9178 14.6653C40.3317 15.2513 40.0025 16.0462 40.0025 16.875C40.0025 17.7038 40.3317 18.4987 40.9178 19.0847C41.5038 19.6708 42.2987 20 43.1275 20C43.9563 20 44.7511 19.6708 45.3372 19.0847C45.9232 18.4987 46.2525 17.7038 46.2525 16.875C46.2525 16.0462 45.9232 15.2513 45.3372 14.6653C44.7511 14.0792 43.9563 13.75 43.1275 13.75Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_1150_317">
            <rect width="60" height="60" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export const Secure1 = () => {
  return (
    <svg
      width="37"
      height="42"
      viewBox="0 0 37 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_251_2189)">
        <g clipPath="url(#clip1_251_2189)">
          <g clipPath="url(#clip2_251_2189)">
            <path
              d="M7.90658 8.30164C7.26643 8.67121 6.87207 9.35422 6.87207 10.0934C6.87207 11.6857 8.59558 12.6812 9.97483 11.8854L17.6956 7.43109C18.3364 7.06138 18.7312 6.3778 18.7312 5.63798C18.7312 4.04442 17.0062 3.04842 15.6261 3.84515L7.90658 8.30164Z"
              fill="url(#paint0_linear_251_2189)"
            />
            <path
              d="M19.7627 7.43109C19.1221 7.06137 18.7274 6.37794 18.7274 5.63831C18.7274 4.04476 20.4526 3.04887 21.8326 3.84582L29.5481 8.30164C30.188 8.67121 30.5822 9.35407 30.5822 10.0931C30.5822 11.6854 28.8585 12.6807 27.4794 11.8848L19.7627 7.43109Z"
              fill="url(#paint1_linear_251_2189)"
            />
            <path
              d="M18.855 6.2955C17.712 6.2955 16.7853 7.22213 16.7853 8.36518V15.8551C16.7853 17.4488 18.5109 18.4445 19.8907 17.647C20.5306 17.2772 20.9247 16.5942 20.9247 15.8551V8.36518C20.9247 7.22213 19.9981 6.2955 18.855 6.2955Z"
              fill="url(#paint2_linear_251_2189)"
            />

            <path
              d="M11.6202 39.3472C12.2603 39.7166 13.0488 39.7167 13.689 39.3473C15.0689 38.551 15.0692 36.5595 13.6896 35.7628L7.90411 32.4216C6.06957 31.3621 3.809 31.3625 1.97481 32.4226L0.799805 33.1017L11.6202 39.3472Z"
              className="fill-black dark:fill-white"
            />
            <path
              d="M4.93917 27.2906C4.93917 29.4083 3.80912 31.3651 1.97487 32.4236L0.799805 33.1017V20.6071C0.799805 19.868 1.19392 19.1851 1.83382 18.8152C3.21361 18.0177 4.93917 19.0135 4.93917 20.6071V27.2906Z"
              className="fill-black dark:fill-white"
            />
            <path
              d="M4.40919 30.871C4.98062 31.8606 6.24601 32.1997 7.2357 31.6284L13.7262 27.8821C15.1059 27.0857 15.1058 25.0943 13.726 24.298C13.086 23.9287 12.2976 23.9287 11.6577 24.2981L5.16688 28.0439C4.17684 28.6153 3.83758 29.8811 4.40919 30.871ZM36.6545 20.6087C36.6545 19.8691 36.2599 19.1857 35.6193 18.8161C34.2395 18.0199 32.5152 19.0157 32.5152 20.6087V30.713C34.3544 31.7761 36.6545 30.4488 36.6545 28.3245V20.6087Z"
              className="fill-black dark:fill-white"
            />
            <path
              d="M32.5152 30.713C34.3546 31.7747 34.355 34.4294 32.5159 35.4916L25.8357 39.3497C25.1947 39.7199 24.4049 39.7198 23.7641 39.3494C22.3844 38.552 22.385 36.5602 23.7651 35.7635L32.5152 30.713Z"
              className="fill-black dark:fill-white"
            />
            <path
              d="M32.9166 31.0901C33.4881 30.1001 33.149 28.8343 32.1591 28.2627L25.6737 24.5179C24.2937 23.721 22.5684 24.717 22.5684 26.3107C22.5684 27.0503 22.963 27.7337 23.6036 28.1035L30.0892 31.8477C31.0792 32.4192 32.345 32.08 32.9166 31.0901Z"
              className="fill-black dark:fill-white"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_251_2189"
          x1="28.8388"
          y1="2.05255"
          x2="5.90995"
          y2="4.66218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#237249" />
          <stop offset="1" stopColor="#35C66B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_251_2189"
          x1="28.8388"
          y1="2.05255"
          x2="5.90995"
          y2="4.66218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#237249" />
          <stop offset="1" stopColor="#35C66B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_251_2189"
          x1="28.8388"
          y1="2.05255"
          x2="5.90995"
          y2="4.66218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#237249" />
          <stop offset="1" stopColor="#35C66B" />
        </linearGradient>
        <clipPath id="clip0_251_2189">
          <rect
            width="36"
            height="42"
            fill="white"
            transform="translate(0.799805)"
          />
        </clipPath>
        <clipPath id="clip1_251_2189">
          <rect
            width="36"
            height="42"
            fill="white"
            transform="translate(0.799805)"
          />
        </clipPath>
        <clipPath id="clip2_251_2189">
          <rect
            width="36"
            height="37.8947"
            fill="white"
            transform="translate(0.799805 2.05264)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Secure2 = () => {
  return (
    <svg
      width="37"
      height="42"
      viewBox="0 0 37 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_251_2201)">
        <g clipPath="url(#clip1_251_2201)">
          <g clipPath="url(#clip2_251_2201)">
            <path
              d="M32.1524 13.2217L18.5227 5.35059C18.5227 3.24949 20.7972 1.93632 22.6168 2.98691L32.1513 8.49195C33.9715 9.54289 33.9721 12.1699 32.1524 13.2217ZM18.5227 5.35059L4.89294 13.2217L0.799805 10.8593L14.432 2.98883C16.2501 1.93918 18.5227 3.25127 18.5227 5.35059Z"
              className="fill-black dark:fill-white"
            />
            <path
              d="M36.2537 31.1736C36.2537 31.1735 36.2536 31.1735 36.2536 31.1735L18.5145 41.3778L18.5227 36.6502L32.0236 28.886C32.1109 28.8358 32.2183 28.836 32.3054 28.8865L36.2526 31.1742C36.2531 31.1745 36.2537 31.1741 36.2537 31.1736Z"
              fill="url(#paint0_linear_251_2201)"
            />
            <path
              d="M18.5145 41.3778L3.87513 32.8939C2.5119 32.1039 2.51504 30.1344 3.88079 29.3487C4.51467 28.9841 5.29494 28.9853 5.92768 29.3519L18.5227 36.6502L18.5145 41.3778Z"
              fill="url(#paint1_linear_251_2201)"
            />
            <path
              d="M33.1737 24.8234C34.5381 25.6132 36.2455 24.6286 36.2455 23.0522V15.5856C36.2455 13.485 33.9719 12.1719 32.1524 13.2217V23.0522C32.1524 23.7825 32.5416 24.4575 33.1737 24.8234ZM17.3745 24.8234C18.7389 25.6132 20.4463 24.6286 20.4463 23.0522V14.4036C20.4463 12.8284 18.7413 11.8437 17.3769 12.631C16.7434 12.9965 16.3532 13.6723 16.3532 14.4036V23.0522C16.3532 23.7825 16.7424 24.4575 17.3745 24.8234ZM3.87161 24.8234C2.50724 25.6132 0.799805 24.6286 0.799805 23.0522V10.8593L4.89294 13.2217V23.0522C4.89294 23.7825 4.50372 24.4575 3.87161 24.8234Z"
              className="fill-black dark:fill-white"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_251_2201"
          x1="33.6468"
          y1="0.623053"
          x2="-0.90081"
          y2="3.13175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#237249" />
          <stop offset="1" stopColor="#35C66B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_251_2201"
          x1="33.6468"
          y1="0.623053"
          x2="-0.90081"
          y2="3.13175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#237249" />
          <stop offset="1" stopColor="#35C66B" />
        </linearGradient>
        <clipPath id="clip0_251_2201">
          <rect
            width="36"
            height="42"
            fill="white"
            transform="translate(0.799805)"
          />
        </clipPath>
        <clipPath id="clip1_251_2201">
          <rect
            width="36"
            height="42"
            fill="white"
            transform="translate(0.799805)"
          />
        </clipPath>
        <clipPath id="clip2_251_2201">
          <rect
            width="36"
            height="40.7547"
            fill="white"
            transform="translate(0.799805 0.623047)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Secure3 = () => {
  return (
    <svg
      width="37"
      height="42"
      viewBox="0 0 37 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_251_2211)">
        <g clipPath="url(#clip1_251_2211)">
          <g clipPath="url(#clip2_251_2211)">
            <path
              d="M25.5645 14.8357L14.7946 8.61626C14.7946 6.9561 16.5918 5.91851 18.0295 6.74861L25.5636 11.0986C27.0018 11.9289 27.0023 14.0046 25.5645 14.8357ZM14.7946 8.61626L4.02467 14.8357C2.58732 14.0064 2.58696 11.9321 4.02402 11.1024L11.5619 6.75022C12.9985 5.92076 14.7943 6.95739 14.7946 8.61626Z"
              className="fill-black dark:fill-white"
            />
            <path
              d="M25.5736 27.1487C27.0098 27.981 27.0064 30.0558 25.5676 30.8834L14.7871 37.0842L14.7935 33.3483L25.5736 27.1487Z"
              fill="url(#paint0_linear_251_2211)"
            />
            <path
              d="M20.1458 16.3454C21.2229 16.9694 21.2206 18.5255 20.1415 19.1463L10.981 24.4162C9.90158 25.0372 8.55476 24.2566 8.55691 23.0113C8.5579 22.4335 8.86707 21.9001 9.36795 21.612L18.529 16.3429C19.0297 16.0549 19.646 16.0559 20.1458 16.3454ZM14.7871 37.0842L3.21978 30.3808C2.14237 29.7564 2.14472 28.1999 3.224 27.5788C3.72509 27.2904 4.34198 27.2913 4.84219 27.5812L14.7935 33.3483L14.7871 37.0842Z"
              className="fill-black dark:fill-white"
            />
            <path
              d="M36.3328 34.3183C36.3306 35.5635 34.9815 36.3394 33.9042 35.7151L25.5679 30.8843C24.1315 30.0519 24.1347 27.9768 25.5736 27.1487L35.5262 32.9159C36.0263 33.2057 36.3338 33.7403 36.3328 34.3183Z"
              fill="url(#paint1_linear_251_2211)"
            />
            <path
              d="M26.3712 24.0036C27.4494 24.6276 28.7986 23.8495 28.7986 22.6038V16.7034C28.7986 15.0437 27.0021 14.0062 25.5645 14.8357L25.564 22.6037C25.564 23.1809 25.8716 23.7144 26.3712 24.0036ZM4.02467 14.8357V26.3371C4.02467 26.9151 3.71621 27.4492 3.21555 27.738C2.13734 28.3601 0.790039 27.5819 0.790039 26.3371V16.7023C0.790039 15.0423 2.5874 14.0051 4.02467 14.8357Z"
              className="fill-black dark:fill-white"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_251_2211"
          x1="33.7208"
          y1="4.88086"
          x2="-0.805124"
          y2="8.05833"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#237249" />
          <stop offset="1" stopColor="#35C66B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_251_2211"
          x1="33.7208"
          y1="4.88086"
          x2="-0.805124"
          y2="8.05833"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#237249" />
          <stop offset="1" stopColor="#35C66B" />
        </linearGradient>
        <clipPath id="clip0_251_2211">
          <rect
            width="36"
            height="42"
            fill="white"
            transform="translate(0.790039)"
          />
        </clipPath>
        <clipPath id="clip1_251_2211">
          <rect
            width="36"
            height="42"
            fill="white"
            transform="translate(0.790039)"
          />
        </clipPath>
        <clipPath id="clip2_251_2211">
          <rect
            width="36"
            height="32.2388"
            fill="white"
            transform="translate(0.790039 4.88086)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
// export const Twitter = () => {
//   return (
//     <div className="text-black dark:text-gray-300">
//       <svg
//         width="19"
//         height="15"
//         viewBox="0 0 19 15"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M12.1587 0.319922H13.0187L13.3187 0.379922C13.5053 0.419922 13.692 0.473255 13.8787 0.539922C14.0653 0.606589 14.2253 0.679922 14.3587 0.759922L14.7987 1.01992C14.9587 1.15326 15.072 1.25326 15.1387 1.31992C15.232 1.41326 15.3853 1.43326 15.5987 1.37992C15.8387 1.33992 16.0653 1.27326 16.2787 1.17992C16.4387 1.12659 16.6787 1.03326 16.9987 0.899922L17.5187 0.639922L17.5387 0.619923H17.5787V0.599922H17.5987V0.579922H17.6387V0.599922L17.6187 0.619923V0.679922L17.5787 0.739923V0.799922L17.4187 1.11992C17.3387 1.26659 17.2153 1.45326 17.0487 1.67992C16.882 1.90659 16.752 2.05992 16.6587 2.13992L16.4187 2.33992C16.4053 2.35326 16.3787 2.37992 16.3387 2.41992L16.2987 2.45992L16.1787 2.53992H16.1587L16.1387 2.55992H16.1187V2.57992H16.0987V2.59992H16.1787L16.6387 2.49992C16.9187 2.44659 17.2053 2.36659 17.4987 2.25992L17.9387 2.11992L17.9787 2.09992H18.0187V2.07992H18.0387L18.0587 2.05992H18.1387V2.07992L18.1187 2.09992H18.0987V2.11992L18.0787 2.13992V2.15992H18.0587C18.0587 2.17326 17.992 2.26659 17.8587 2.43992L17.6387 2.71992C17.6253 2.71992 17.6187 2.72659 17.6187 2.73992L17.5987 2.75992C17.5853 2.78659 17.4653 2.91326 17.2387 3.13992C17.052 3.32659 16.852 3.50659 16.6387 3.67992C16.4253 3.85326 16.3187 4.05992 16.3187 4.29992C16.3187 4.44659 16.3053 4.69992 16.2787 5.05992V5.11992C16.2653 5.41326 16.2253 5.73992 16.1587 6.09992C16.1053 6.39326 16.012 6.78659 15.8787 7.27992C15.7987 7.58659 15.652 8.01992 15.4387 8.57992C15.3187 8.87326 15.132 9.25326 14.8787 9.71992C14.7187 9.99992 14.5387 10.2866 14.3387 10.5799C14.2453 10.6999 14.1053 10.8799 13.9187 11.1199L13.8387 11.2199C13.732 11.3666 13.5187 11.5999 13.1987 11.9199L12.7787 12.3399C12.6987 12.4199 12.592 12.5066 12.4587 12.5999C12.2853 12.7599 12.0853 12.9199 11.8587 13.0799L11.5987 13.2399C11.452 13.3466 11.3453 13.4199 11.2787 13.4599C11.0253 13.5933 10.8053 13.7066 10.6187 13.7999C10.4587 13.8933 10.192 14.0199 9.81867 14.1799C9.53867 14.2866 9.22534 14.3933 8.87867 14.4999C8.65201 14.5666 8.33867 14.6399 7.93867 14.7199C7.71201 14.7599 7.372 14.8066 6.91867 14.8599L6.33867 14.9199H5.27867L5.13867 14.8999H4.91867L4.03867 14.7599C3.69201 14.7066 3.45867 14.6666 3.33867 14.6399C3.16534 14.5999 2.83201 14.4999 2.33867 14.3399C1.93867 14.1933 1.56534 14.0399 1.21867 13.8799L0.358672 13.4399L0.218672 13.3399H0.198672V13.3199H0.178672V13.2999H0.158672V13.2799H0.138672V13.2599H0.238672C0.265339 13.2733 0.332005 13.2799 0.438672 13.2799L0.638672 13.2999H1.33867C1.65867 13.2733 1.90534 13.2466 2.07867 13.2199C2.38534 13.1666 2.68534 13.0999 2.97867 13.0199C3.23201 12.9533 3.55201 12.8466 3.93867 12.6999C4.21867 12.5799 4.42201 12.4866 4.54867 12.4199C4.67534 12.3533 4.85867 12.2333 5.09867 12.0599L5.49867 11.7999H5.51867V11.7799H5.53867V11.7599L5.55867 11.7399L5.43867 11.7199H5.17867L4.79867 11.6399C4.61201 11.5999 4.42534 11.5333 4.23867 11.4399C4.02534 11.3466 3.83201 11.2466 3.65867 11.1399C3.45867 11.0199 3.31867 10.9199 3.23867 10.8399L2.91867 10.5199C2.79867 10.3733 2.68534 10.2233 2.57867 10.0699C2.47201 9.91659 2.37867 9.73992 2.29867 9.53992L2.15867 9.23992V9.21992L2.13867 9.19992V9.15992L2.15867 9.17992L2.35867 9.19992C2.43867 9.21326 2.62534 9.21992 2.91867 9.21992C3.14534 9.21992 3.32534 9.20659 3.45867 9.17992C3.51201 9.16659 3.57201 9.15992 3.63867 9.15992L3.65867 9.13992H3.69867L3.73867 9.11992H3.75867L3.71867 9.09992H3.69867L3.65867 9.07992H3.59867C3.58534 9.06659 3.56534 9.05992 3.53867 9.05992L3.47867 9.03992L3.03867 8.85992C2.81201 8.76659 2.62534 8.66659 2.47867 8.55992C2.29201 8.42659 2.15867 8.32326 2.07867 8.24992C1.99867 8.17659 1.87867 8.04659 1.71867 7.85992L1.65867 7.79992C1.51201 7.62659 1.37867 7.41326 1.25867 7.15992C1.11201 6.83992 1.01867 6.60659 0.978672 6.45992C0.925339 6.24659 0.885339 6.01992 0.858672 5.77992L0.838672 5.43992H0.878672V5.45992H0.898672L0.918672 5.47992H0.938672L1.17867 5.59992C1.36534 5.67992 1.57867 5.73992 1.81867 5.77992C2.08534 5.84659 2.23201 5.87992 2.25867 5.87992H2.47867H2.45867V5.85992H2.43867L2.39867 5.81992H2.37867L2.21867 5.69992L1.93867 5.43992L1.83867 5.33992C1.75867 5.23326 1.69867 5.15326 1.65867 5.09992C1.53867 4.95326 1.44867 4.82326 1.38867 4.70992C1.32867 4.59659 1.25201 4.43326 1.15867 4.21992C1.06534 4.00659 0.998672 3.78659 0.958672 3.55992C0.932005 3.43992 0.905339 3.25326 0.878672 2.99992V2.93992C0.878672 2.68659 0.885339 2.51326 0.898672 2.41992C0.912005 2.32659 0.945339 2.15992 0.998672 1.91992C1.03867 1.74659 1.11201 1.55326 1.21867 1.33992L1.35867 1.03992V0.979922H1.37867H1.39867V0.999922H1.41867V1.01992L1.65867 1.27992C1.75201 1.38659 1.92534 1.56659 2.17867 1.81992C2.37867 2.01992 2.48867 2.12326 2.50867 2.12992C2.52867 2.13659 2.54534 2.15326 2.55867 2.17992L2.59867 2.21992C2.61201 2.23326 2.65201 2.27326 2.71867 2.33992L2.91867 2.49992C3.03867 2.60659 3.27867 2.77992 3.63867 3.01992C3.97201 3.24659 4.29867 3.44659 4.61867 3.61992C4.93867 3.79326 5.33201 3.96659 5.79867 4.13992C6.17201 4.28659 6.46534 4.39326 6.67867 4.45992C6.86534 4.49992 7.15201 4.55992 7.53867 4.63992C7.88534 4.70659 8.19201 4.75326 8.45867 4.77992L8.87867 4.81992H8.97867L8.93867 4.57992C8.92534 4.48659 8.91867 4.29326 8.91867 3.99992C8.91867 3.75992 8.93867 3.53992 8.97867 3.33992C8.99201 3.16659 9.04534 2.95326 9.13867 2.69992C9.21867 2.49992 9.292 2.33326 9.35867 2.19992L9.65867 1.75992C9.792 1.58659 9.94867 1.41659 10.1287 1.24992C10.3087 1.08326 10.5187 0.933255 10.7587 0.799922C11.0787 0.639922 11.3053 0.539922 11.4387 0.499922C11.612 0.433255 11.7853 0.386589 11.9587 0.359922L12.1587 0.319922Z"
//           fill="currentColor"
//         />
//       </svg>
//     </div>
//   );
// };
export const Instagram = () => {
  return (
    <div className="text-black dark:text-gray-300">
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3387 10.3203C13.3387 10.9336 13.1587 11.527 12.7987 12.1003C12.4653 12.6203 11.9853 13.0136 11.3587 13.2803C10.772 13.5203 10.1553 13.5803 9.50867 13.4603C8.86201 13.3403 8.31201 13.0536 7.85867 12.6003C7.40534 12.147 7.11534 11.5903 6.98867 10.9303C6.86201 10.2703 6.92534 9.66031 7.17867 9.10031C7.432 8.50031 7.82867 8.02031 8.36867 7.66031C8.90867 7.30031 9.49867 7.12031 10.1387 7.12031C10.5653 7.12031 10.9753 7.20365 11.3687 7.37031C11.762 7.53698 12.1053 7.76698 12.3987 8.06031C12.692 8.35365 12.922 8.69698 13.0887 9.09031C13.2553 9.48365 13.3387 9.89365 13.3387 10.3203ZM20.1387 5.92031V14.7203C20.1387 15.4536 19.9953 16.1636 19.7087 16.8503C19.422 17.537 19.0153 18.1436 18.4887 18.6703C17.962 19.197 17.3553 19.6036 16.6687 19.8903C15.982 20.177 15.272 20.3203 14.5387 20.3203H5.73867C5.00534 20.3203 4.29534 20.177 3.60867 19.8903C2.92201 19.6036 2.31534 19.197 1.78867 18.6703C1.26201 18.1436 0.855339 17.537 0.568672 16.8503C0.282005 16.1636 0.138672 15.4536 0.138672 14.7203V5.92031C0.138672 5.18698 0.282005 4.47698 0.568672 3.79031C0.855339 3.10365 1.26201 2.49698 1.78867 1.97031C2.31534 1.44365 2.92201 1.03698 3.60867 0.750313C4.29534 0.463646 5.00534 0.320312 5.73867 0.320312H14.5387C15.272 0.320312 15.982 0.463646 16.6687 0.750313C17.3553 1.03698 17.962 1.44365 18.4887 1.97031C19.0153 2.49698 19.422 3.10365 19.7087 3.79031C19.9953 4.47698 20.1387 5.18698 20.1387 5.92031ZM14.9187 10.3203C14.9187 9.36031 14.652 8.46698 14.1187 7.64031C13.8653 7.25365 13.552 6.91031 13.1787 6.61031C12.8053 6.31031 12.4053 6.06698 11.9787 5.88031C11.072 5.50698 10.1453 5.41365 9.19867 5.60031C8.22534 5.81365 7.412 6.25365 6.75867 6.92031C6.06534 7.61365 5.62534 8.43365 5.43867 9.38031C5.34534 9.83365 5.32201 10.3003 5.36867 10.7803C5.41534 11.2603 5.52867 11.717 5.70867 12.1503C5.88867 12.5836 6.12867 12.9836 6.42867 13.3503C6.72867 13.717 7.07867 14.0336 7.47867 14.3003C8.30534 14.8336 9.19867 15.1003 10.1587 15.1003C10.7853 15.1003 11.392 14.977 11.9787 14.7303C12.5653 14.4836 13.0853 14.1336 13.5387 13.6803C13.992 13.227 14.3387 12.7103 14.5787 12.1303C14.8187 11.5503 14.9453 10.9403 14.9587 10.3003L14.9187 10.3203ZM16.5187 5.12031C16.5187 4.86698 16.452 4.64698 16.3187 4.46031C16.172 4.24698 15.992 4.09698 15.7787 4.01031C15.5653 3.92365 15.3387 3.90031 15.0987 3.94031C14.8587 3.98031 14.6487 4.09031 14.4687 4.27031C14.2887 4.45031 14.1787 4.65698 14.1387 4.89031C14.0987 5.12365 14.1187 5.35365 14.1987 5.58031C14.2653 5.76698 14.412 5.94698 14.6387 6.12031C14.852 6.26698 15.072 6.34031 15.2987 6.34031C15.6053 6.34031 15.892 6.22031 16.1587 5.98031C16.3853 5.75365 16.4987 5.47365 16.4987 5.14031L16.5187 5.12031Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
export const Linkedin = () => {
  return (
    <div className="text-black dark:text-gray-300">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        width="26px"
        height="26px"
      >
        <path fill="currentColor" d="M 44.898438 14.5 C 44.5 12.300781 42.601563 10.699219 40.398438 10.199219 C 37.101563 9.5 31 9 24.398438 9 C 17.800781 9 11.601563 9.5 8.300781 10.199219 C 6.101563 10.699219 4.199219 12.199219 3.800781 14.5 C 3.398438 17 3 20.5 3 25 C 3 29.5 3.398438 33 3.898438 35.5 C 4.300781 37.699219 6.199219 39.300781 8.398438 39.800781 C 11.898438 40.5 17.898438 41 24.5 41 C 31.101563 41 37.101563 40.5 40.601563 39.800781 C 42.800781 39.300781 44.699219 37.800781 45.101563 35.5 C 45.5 33 46 29.398438 46.101563 25 C 45.898438 20.5 45.398438 17 44.898438 14.5 Z M 19 32 L 19 18 L 31.199219 25 Z" />
      </svg>
    </div>
  );
};

export const Twitter = () => {
  return (
    <div className="text-black dark:text-gray-300">
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 27"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.75 4.61694H18.8175L12.1175 12.2944L20 22.7419H13.8287L8.995 16.4044L3.46375 22.7419H0.395L7.56125 14.5294L0 4.61694H6.32875L10.6975 10.4082L15.75 4.61694ZM14.675 20.9019H16.375L5.40375 6.36069H3.58125L14.675 20.9019Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
